<template>
  <Navbar />
  <Hero />
  <MainBody />
  <Videos />
  <Faqs />
  <img src="./assets/img/city.webp" alt="" class="footer-image" :class="{'grey' : isAuEm}" @click="CookieValue" width="1578" height="377">
  <Footer />
  <div class="backTop" id="backTop" @click="scrollToTop"></div>
  <pie-cookie-banner id="ie-cookie-banner" v-if="isIE" cookieStatementLink="https://takeaway-landing-pages.k.elnino-production.com/storage/resources/delco-landing/Global_Cookie_Statement.pdf" cookieTechnologiesLink="https://www.just-eat.ie/technologies"></pie-cookie-banner>
  <AusNZCookie v-if="isAusNZ"></AusNZCookie>
  <GBCookie v-if="isGB"></GBCookie>
</template>

<script>
import Navbar from './components/Navbar.vue'
import MainBody from './components/MainBody.vue'
import Hero from './components/Hero.vue'
import Videos from './components/Videos.vue'
import Faqs from './components/Faqs.vue'
import Footer from './components/Footer.vue'
import '@justeattakeaway/pie-cookie-banner'
import AusNZCookie from './components/AusNZCookie.vue'
import GBCookie from './components/GBCookie.vue'

import Content from "/src/data/content";
import { ON_COOKIE_BANNER_ACCEPT_ALL } from '@justeattakeaway/pie-cookie-banner'
let lang = process.env.VUE_APP_LOCALITY;

export default {
  mounted() {
    if (lang == 'ca_fr' || lang == 'ca_en') {
      window.addEventListener('load', () => this.addDataLayer());
    }
    if (lang == 'ie_ie') {
      window.addEventListener('load', () => this.CookieValue());
    }
    window.addEventListener('load', () => this.injectCanonical());
  },
  name: 'App',
  components: {
    Navbar,
    Hero,
    MainBody,
    Videos,
    Faqs,
    Footer,
    AusNZCookie,
    GBCookie,
  },
  methods: {
    async scrollToTop() {
      window.scrollTo(0,0);
    },
     addDataLayer() {
      window.dataLayer = window.dataLayer || [];
        dataLayer.push({
          "event": "trackPageview",
          "page_name": "Delco Courier Recruitment Landing Page",
          "page_id": "e3502a25-95e1-4e1e-8b7a-c19b3f6855b2",
          "platform_country" : Content[lang].gtm.countryPlatform,
          "platform_environment" : "production",
          "platform_language" :  Content[lang].gtm.platform_language,
          "user_anonymousId" :  "58a7d972-df88-44b0-b2bd-89ea37031ba6",
      });
    },
    getCookie(cname) {
      let name = cname + "=";
      let decodedCookie = decodeURIComponent(document.cookie);
      let ca = decodedCookie.split(';');
      for(let i = 0; i <ca.length; i++) {
        let c = ca[i];
        while (c.charAt(0) == ' ') {
          c = c.substring(1);
        }
        if (c.indexOf(name) == 0) {
          return c.substring(name.length, c.length);
        }
      }
      return "";
    },
    CookieValue() {
      let cookieBanner = document.getElementById('ie-cookie-banner');
      let cookie;
      let name = "jet-consent-courierweb=";
      let decodedCookie = decodeURIComponent(document.cookie);
      let ca = decodedCookie.split(';');
      for(let i = 0; i <ca.length; i++) {
        let c = ca[i];
        while (c.charAt(0) == ' ') {
          c = c.substring(1);
        }
        if (c.indexOf(name) == 0) {
          cookie = c.substring(name.length, c.length);
        }
      }
      if (cookie == undefined) {
        cookieBanner.classList.add('display');
        let acceptAll = cookieBanner.shadowRoot.querySelector('[data-test-id="actions-accept-all"]');
        let necessaryOnly = cookieBanner.shadowRoot.querySelector('[data-test-id="actions-necessary-only"]');
        let allCookies = cookieBanner.shadowRoot.getElementById('all')
        let functionalCookies = cookieBanner.shadowRoot.getElementById('functional');
        let analyticalCookies = cookieBanner.shadowRoot.getElementById('analytical');
        let personalizedCookies = cookieBanner.shadowRoot.getElementById('personalized');
        let saveButton = cookieBanner.shadowRoot.querySelectorAll('pie-modal')[0].shadowRoot.querySelector('[data-test-id="modal-leading-action"]');

        acceptAll.addEventListener('click', function() {
          document.cookie = 'jet-consent-courierweb=full';
          //Set Data Layer
          window.dataLayer = window.dataLayer || [];
            dataLayer.push({
              "event": "trackPageview",
              "page_name": "Delco Courier Recruitment Landing Page",
              "page_id": "e3502a25-95e1-4e1e-8b7a-c19b3f6855b2",
              "platform_country" : Content[lang].gtm.countryPlatform,
              "platform_environment" : "production",
              "platform_language" :  Content[lang].gtm.platform_language,
              "user_anonymousId" :  "58a7d972-df88-44b0-b2bd-89ea37031ba6",
          });
        });
        necessaryOnly.addEventListener('click', function() {
          document.cookie = 'jet-consent-courierweb=necessary'
          //Set Data Layer
          window.dataLayer = window.dataLayer || [];
            dataLayer.push({
              "event": "trackPageview",
              "page_name": "Delco Courier Recruitment Landing Page",
              "page_id": "e3502a25-95e1-4e1e-8b7a-c19b3f6855b2",
              "platform_country" : Content[lang].gtm.countryPlatform,
              "platform_environment" : "production",
              "platform_language" :  Content[lang].gtm.platform_language,
              "user_anonymousId" :  "58a7d972-df88-44b0-b2bd-89ea37031ba6",
          });
        });
        saveButton.addEventListener('click', function() {
          if (allCookies.checked == 1) {
            document.cookie = 'jet-consent-courierweb=full';
            //Set Data Layer
            window.dataLayer = window.dataLayer || [];
              dataLayer.push({
                "event": "trackPageview",
                "page_name": "Delco Courier Recruitment Landing Page",
                "page_id": "e3502a25-95e1-4e1e-8b7a-c19b3f6855b2",
                "platform_country" : Content[lang].gtm.countryPlatform,
                "platform_environment" : "production",
                "platform_language" :  Content[lang].gtm.platform_language,
                "user_anonymousId" :  "58a7d972-df88-44b0-b2bd-89ea37031ba6",
            });
          } else {
            let fun = '';
            let anal = '';
            let pers = '';
            let count = 0;
            let space = '%20';

            if (functionalCookies.checked == 1) {
              fun = 'functional';
              count++;
            }

            if (analyticalCookies.checked == 1) {
              if (count > 0) {
                anal = '%20analytics';
              } else {
                anal = 'analytics';
              }
              count++;
            }

            if (personalizedCookies.checked == 1) {
              if (count > 0) {
                pers = '%20personalized';
              } else {
                pers = 'personalized';
              }
            }

            let val = fun + anal + pers;

            document.cookie = 'jet-consent-courierweb=' + val;
            //Set Data Layer
            window.dataLayer = window.dataLayer || [];
              dataLayer.push({
                "event": "trackPageview",
                "page_name": "Delco Courier Recruitment Landing Page",
                "page_id": "e3502a25-95e1-4e1e-8b7a-c19b3f6855b2",
                "platform_country" : Content[lang].gtm.countryPlatform,
                "platform_environment" : "production",
                "platform_language" :  Content[lang].gtm.platform_language,
                "user_anonymousId" :  "58a7d972-df88-44b0-b2bd-89ea37031ba6",
            });
          }


        })
      } else {
        window.dataLayer = window.dataLayer || [];
        dataLayer.push({
          "event": "trackPageview",
          "page_name": "Delco Courier Recruitment Landing Page",
          "page_id": "e3502a25-95e1-4e1e-8b7a-c19b3f6855b2",
          "platform_country" : Content[lang].gtm.countryPlatform,
          "platform_environment" : "production",
          "platform_language" :  Content[lang].gtm.platform_language,
          "user_anonymousId" :  "58a7d972-df88-44b0-b2bd-89ea37031ba6",
      });
      }
    },
    injectCanonical() {
      // let head = document.getElementsByTagName('head');
      // let html = document.getElementsByTagName('html');
      // let canonical = document.createElement('link');
      // canonical.rel = 'canonical';
      // canonical.href = Content[lang].canonical.canonical;
      // head[0].appendChild(canonical);
      // for (let i = -1; i < Content[lang].canonical.alt.length; i++) {
      //   let altTag = document.createElement('link');
      //   altTag.rel = 'alternate';
      //   if (i == -1) {
      //     altTag.href = Content[lang].canonical.alt[0].url;
      //     altTag.hreflang = 'x-default';
      //   } else {
      //     altTag.href = Content[lang].canonical.alt[i].url;
      //     altTag.hreflang = Content[lang].canonical.alt[i].lang;
      //   }
      //   head[0].appendChild(altTag);
      // }
      // html[0].lang = Content[lang].canonical.lang;
    }

  },
  setup() {
    return {
      isIE: lang == 'ie_ie' ? true : false,
      isAusNZ: lang == 'pl_en' || lang == 'at_en' || lang == 'de_en' ? true : false,
      isGB: lang == 'gb_en' ? true : false,
      isCA: lang == 'ca_en' || lang == 'ca_fr' ? true : false,
      isAuEm: lang == 'pl_en' ? true : false
    };
  },
}
</script>

<style>

@font-face {
    font-family: "jet-regular";
    font-weight: normal;
    font-style: normal;
    src: url("https://takeaway-landing-pages.k.elnino-production.com/storage/resources/fonts/jet-sans/eot/JETSansDigital-Regular.eot"),
      url("https://takeaway-landing-pages.k.elnino-production.com/storage/resources/fonts/jet-sans/eot/JETSansDigital-Regular.eot?#iefix") format("embedded-opentype"),
      url("https://takeaway-landing-pages.k.elnino-production.com/storage/resources/fonts/jet-sans/woff2/JETSansDigital-Regular.woff2") format("woff2"),
      url("https://takeaway-landing-pages.k.elnino-production.com/storage/resources/fonts/jet-sans/woff/JETSansDigital-Regular.woff") format("woff")
  }
  
  @font-face {
    font-family: "jet-italic";
    font-weight: normal;
    font-style: normal;
    src: url("https://takeaway-landing-pages.k.elnino-production.com/storage/resources/fonts/jet-sans/eot/JETSansDigital-Italic.eot"),
      url("https://takeaway-landing-pages.k.elnino-production.com/storage/resources/fonts/jet-sans/eot/JETSansDigital-Italic.eot?#iefix") format("embedded-opentype"),
      url("https://takeaway-landing-pages.k.elnino-production.com/storage/resources/fonts/jet-sans/woff2/JETSansDigital-Italic.woff2") format("woff2"),
      url("https://takeaway-landing-pages.k.elnino-production.com/storage/resources/fonts/jet-sans/woff/JETSansDigital-Italic.woff") format("woff")
  }
  
  @font-face {
    font-family: "jet-bold";
    font-weight: normal;
    font-style: normal;
    src: url("https://takeaway-landing-pages.k.elnino-production.com/storage/resources/fonts/jet-sans/eot/JETSansDigital-Bold.eot"),
      url("https://takeaway-landing-pages.k.elnino-production.com/storage/resources/fonts/jet-sans/eot/JETSansDigital-Bold.eot?#iefix") format("embedded-opentype"),
      url("https://takeaway-landing-pages.k.elnino-production.com/storage/resources/fonts/jet-sans/woff2/JETSansDigital-Bold.woff2") format("woff2"),
      url("https://takeaway-landing-pages.k.elnino-production.com/storage/resources/fonts/jet-sans/woff/JETSansDigital-Bold.woff") format("woff")
  }
  
  @font-face {
    font-family: "jet-bold-Italic";
    font-weight: normal;
    font-style: normal;
    src: url("https://takeaway-landing-pages.k.elnino-production.com/storage/resources/fonts/jet-sans/eot/JETSansDigital-BoldItalic.eot"),
      url("https://takeaway-landing-pages.k.elnino-production.com/storage/resources/fonts/jet-sans/eot/JETSansDigital-BoldItalic.eot?#iefix") format("embedded-opentype"),
      url("https://takeaway-landing-pages.k.elnino-production.com/storage/resources/fonts/jet-sans/woff2/JETSansDigital-BoldItalic.woff2") format("woff2"),
      url("https://takeaway-landing-pages.k.elnino-production.com/storage/resources/fonts/jet-sans/woff/JETSansDigital-BoldItalic.woff") format("woff")
  }
  
  @font-face {
    font-family: "jet-extrabold";
    font-weight: normal;
    font-style: normal;
    src: url("https://takeaway-landing-pages.k.elnino-production.com/storage/resources/fonts/jet-sans/eot/JETSansDigital-ExtraBold.eot"),
      url("https://takeaway-landing-pages.k.elnino-production.com/storage/resources/fonts/jet-sans/eot/JETSansDigital-ExtraBold.eot?#iefix") format("embedded-opentype"),
      url("https://takeaway-landing-pages.k.elnino-production.com/storage/resources/fonts/jet-sans/woff2/JETSansDigital-ExtraBold.woff2") format("woff2"),
      url("https://takeaway-landing-pages.k.elnino-production.com/storage/resources/fonts/jet-sans/woff/JETSansDigital-ExtraBold.woff") format("woff")
  }
  
  @font-face {
    font-family: "jet-extrabold-Italic";
    font-weight: normal;
    font-style: normal;
    src: url("https://takeaway-landing-pages.k.elnino-production.com/storage/resources/fonts/jet-sans/eot/JETSansDigital-ExtraBoldItalic.eot"),
      url("https://takeaway-landing-pages.k.elnino-production.com/storage/resources/fonts/jet-sans/eot/JETSansDigital-ExtraBoldItalic.eot?#iefix") format("embedded-opentype"),
      url("https://takeaway-landing-pages.k.elnino-production.com/storage/resources/fonts/jet-sans/woff2/JETSansDigital-ExtraBoldItalic.woff2") format("woff2"),
      url("https://takeaway-landing-pages.k.elnino-production.com/storage/resources/fonts/jet-sans/woff/JETSansDigital-ExtraBoldItalic.woff") format("woff")
  }
@font-face {
    font-family: "jet-regular";
    font-weight: normal;
    font-style: normal;
    src: url("https://takeaway-landing-pages.k.elnino-production.com/storage/resources/fonts/jet-sans/eot/JETSansDigital-Regular.eot"),
      url("https://takeaway-landing-pages.k.elnino-production.com/storage/resources/fonts/jet-sans/eot/JETSansDigital-Regular.eot?#iefix") format("embedded-opentype"),
      url("https://takeaway-landing-pages.k.elnino-production.com/storage/resources/fonts/jet-sans/woff2/JETSansDigital-Regular.woff2") format("woff2"),
      url("https://takeaway-landing-pages.k.elnino-production.com/storage/resources/fonts/jet-sans/woff/JETSansDigital-Regular.woff") format("woff")
  }
  
  @font-face {
    font-family: "jet-italic";
    font-weight: normal;
    font-style: normal;
    src: url("https://takeaway-landing-pages.k.elnino-production.com/storage/resources/fonts/jet-sans/eot/JETSansDigital-Italic.eot"),
      url("https://takeaway-landing-pages.k.elnino-production.com/storage/resources/fonts/jet-sans/eot/JETSansDigital-Italic.eot?#iefix") format("embedded-opentype"),
      url("https://takeaway-landing-pages.k.elnino-production.com/storage/resources/fonts/jet-sans/woff2/JETSansDigital-Italic.woff2") format("woff2"),
      url("https://takeaway-landing-pages.k.elnino-production.com/storage/resources/fonts/jet-sans/woff/JETSansDigital-Italic.woff") format("woff")
  }
  
  @font-face {
    font-family: "jet-bold";
    font-weight: normal;
    font-style: normal;
    src: url("https://takeaway-landing-pages.k.elnino-production.com/storage/resources/fonts/jet-sans/eot/JETSansDigital-Bold.eot"),
      url("https://takeaway-landing-pages.k.elnino-production.com/storage/resources/fonts/jet-sans/eot/JETSansDigital-Bold.eot?#iefix") format("embedded-opentype"),
      url("https://takeaway-landing-pages.k.elnino-production.com/storage/resources/fonts/jet-sans/woff2/JETSansDigital-Bold.woff2") format("woff2"),
      url("https://takeaway-landing-pages.k.elnino-production.com/storage/resources/fonts/jet-sans/woff/JETSansDigital-Bold.woff") format("woff")
  }
  
  @font-face {
    font-family: "jet-bold-Italic";
    font-weight: normal;
    font-style: normal;
    src: url("https://takeaway-landing-pages.k.elnino-production.com/storage/resources/fonts/jet-sans/eot/JETSansDigital-BoldItalic.eot"),
      url("https://takeaway-landing-pages.k.elnino-production.com/storage/resources/fonts/jet-sans/eot/JETSansDigital-BoldItalic.eot?#iefix") format("embedded-opentype"),
      url("https://takeaway-landing-pages.k.elnino-production.com/storage/resources/fonts/jet-sans/woff2/JETSansDigital-BoldItalic.woff2") format("woff2"),
      url("https://takeaway-landing-pages.k.elnino-production.com/storage/resources/fonts/jet-sans/woff/JETSansDigital-BoldItalic.woff") format("woff")
  }
  
  @font-face {
    font-family: "jet-extrabold";
    font-weight: normal;
    font-style: normal;
    src: url("https://takeaway-landing-pages.k.elnino-production.com/storage/resources/fonts/jet-sans/eot/JETSansDigital-ExtraBold.eot"),
      url("https://takeaway-landing-pages.k.elnino-production.com/storage/resources/fonts/jet-sans/eot/JETSansDigital-ExtraBold.eot?#iefix") format("embedded-opentype"),
      url("https://takeaway-landing-pages.k.elnino-production.com/storage/resources/fonts/jet-sans/woff2/JETSansDigital-ExtraBold.woff2") format("woff2"),
      url("https://takeaway-landing-pages.k.elnino-production.com/storage/resources/fonts/jet-sans/woff/JETSansDigital-ExtraBold.woff") format("woff")
  }
  
  @font-face {
    font-family: "jet-extrabold-Italic";
    font-weight: normal;
    font-style: normal;
    src: url("https://takeaway-landing-pages.k.elnino-production.com/storage/resources/fonts/jet-sans/eot/JETSansDigital-ExtraBoldItalic.eot"),
      url("https://takeaway-landing-pages.k.elnino-production.com/storage/resources/fonts/jet-sans/eot/JETSansDigital-ExtraBoldItalic.eot?#iefix") format("embedded-opentype"),
      url("https://takeaway-landing-pages.k.elnino-production.com/storage/resources/fonts/jet-sans/woff2/JETSansDigital-ExtraBoldItalic.woff2") format("woff2"),
      url("https://takeaway-landing-pages.k.elnino-production.com/storage/resources/fonts/jet-sans/woff/JETSansDigital-ExtraBoldItalic.woff") format("woff")
  }
@font-face {
    font-family: "jet-regular";
    font-weight: normal;
    font-style: normal;
    src: url("https://takeaway-landing-pages.k.elnino-production.com/storage/resources/fonts/jet-sans/eot/JETSansDigital-Regular.eot"),
      url("https://takeaway-landing-pages.k.elnino-production.com/storage/resources/fonts/jet-sans/eot/JETSansDigital-Regular.eot?#iefix") format("embedded-opentype"),
      url("https://takeaway-landing-pages.k.elnino-production.com/storage/resources/fonts/jet-sans/woff2/JETSansDigital-Regular.woff2") format("woff2"),
      url("https://takeaway-landing-pages.k.elnino-production.com/storage/resources/fonts/jet-sans/woff/JETSansDigital-Regular.woff") format("woff")
  }
  
  @font-face {
    font-family: "jet-italic";
    font-weight: normal;
    font-style: normal;
    src: url("https://takeaway-landing-pages.k.elnino-production.com/storage/resources/fonts/jet-sans/eot/JETSansDigital-Italic.eot"),
      url("https://takeaway-landing-pages.k.elnino-production.com/storage/resources/fonts/jet-sans/eot/JETSansDigital-Italic.eot?#iefix") format("embedded-opentype"),
      url("https://takeaway-landing-pages.k.elnino-production.com/storage/resources/fonts/jet-sans/woff2/JETSansDigital-Italic.woff2") format("woff2"),
      url("https://takeaway-landing-pages.k.elnino-production.com/storage/resources/fonts/jet-sans/woff/JETSansDigital-Italic.woff") format("woff")
  }
  
  @font-face {
    font-family: "jet-bold";
    font-weight: normal;
    font-style: normal;
    src: url("https://takeaway-landing-pages.k.elnino-production.com/storage/resources/fonts/jet-sans/eot/JETSansDigital-Bold.eot"),
      url("https://takeaway-landing-pages.k.elnino-production.com/storage/resources/fonts/jet-sans/eot/JETSansDigital-Bold.eot?#iefix") format("embedded-opentype"),
      url("https://takeaway-landing-pages.k.elnino-production.com/storage/resources/fonts/jet-sans/woff2/JETSansDigital-Bold.woff2") format("woff2"),
      url("https://takeaway-landing-pages.k.elnino-production.com/storage/resources/fonts/jet-sans/woff/JETSansDigital-Bold.woff") format("woff")
  }
  
  @font-face {
    font-family: "jet-bold-Italic";
    font-weight: normal;
    font-style: normal;
    src: url("https://takeaway-landing-pages.k.elnino-production.com/storage/resources/fonts/jet-sans/eot/JETSansDigital-BoldItalic.eot"),
      url("https://takeaway-landing-pages.k.elnino-production.com/storage/resources/fonts/jet-sans/eot/JETSansDigital-BoldItalic.eot?#iefix") format("embedded-opentype"),
      url("https://takeaway-landing-pages.k.elnino-production.com/storage/resources/fonts/jet-sans/woff2/JETSansDigital-BoldItalic.woff2") format("woff2"),
      url("https://takeaway-landing-pages.k.elnino-production.com/storage/resources/fonts/jet-sans/woff/JETSansDigital-BoldItalic.woff") format("woff")
  }
  
  @font-face {
    font-family: "jet-extrabold";
    font-weight: normal;
    font-style: normal;
    src: url("https://takeaway-landing-pages.k.elnino-production.com/storage/resources/fonts/jet-sans/eot/JETSansDigital-ExtraBold.eot"),
      url("https://takeaway-landing-pages.k.elnino-production.com/storage/resources/fonts/jet-sans/eot/JETSansDigital-ExtraBold.eot?#iefix") format("embedded-opentype"),
      url("https://takeaway-landing-pages.k.elnino-production.com/storage/resources/fonts/jet-sans/woff2/JETSansDigital-ExtraBold.woff2") format("woff2"),
      url("https://takeaway-landing-pages.k.elnino-production.com/storage/resources/fonts/jet-sans/woff/JETSansDigital-ExtraBold.woff") format("woff")
  }
  
  @font-face {
    font-family: "jet-extrabold-Italic";
    font-weight: normal;
    font-style: normal;
    src: url("https://takeaway-landing-pages.k.elnino-production.com/storage/resources/fonts/jet-sans/eot/JETSansDigital-ExtraBoldItalic.eot"),
      url("https://takeaway-landing-pages.k.elnino-production.com/storage/resources/fonts/jet-sans/eot/JETSansDigital-ExtraBoldItalic.eot?#iefix") format("embedded-opentype"),
      url("https://takeaway-landing-pages.k.elnino-production.com/storage/resources/fonts/jet-sans/woff2/JETSansDigital-ExtraBoldItalic.woff2") format("woff2"),
      url("https://takeaway-landing-pages.k.elnino-production.com/storage/resources/fonts/jet-sans/woff/JETSansDigital-ExtraBoldItalic.woff") format("woff")
  }


  * {
    text-rendering: optimizeSpeed;
    font-variant-ligatures: no-common-ligature;
    font-variant-ligatures: none;
@font-face {
    font-family: "jet-regular";
    font-weight: normal;
    font-style: normal;
    src: url("https://takeaway-landing-pages.k.elnino-production.com/storage/resources/fonts/jet-sans/eot/JETSansDigital-Regular.eot"),
      url("https://takeaway-landing-pages.k.elnino-production.com/storage/resources/fonts/jet-sans/eot/JETSansDigital-Regular.eot?#iefix") format("embedded-opentype"),
      url("https://takeaway-landing-pages.k.elnino-production.com/storage/resources/fonts/jet-sans/woff2/JETSansDigital-Regular.woff2") format("woff2"),
      url("https://takeaway-landing-pages.k.elnino-production.com/storage/resources/fonts/jet-sans/woff/JETSansDigital-Regular.woff") format("woff")
  }
  
  @font-face {
    font-family: "jet-italic";
    font-weight: normal;
    font-style: normal;
    src: url("https://takeaway-landing-pages.k.elnino-production.com/storage/resources/fonts/jet-sans/eot/JETSansDigital-Italic.eot"),
      url("https://takeaway-landing-pages.k.elnino-production.com/storage/resources/fonts/jet-sans/eot/JETSansDigital-Italic.eot?#iefix") format("embedded-opentype"),
      url("https://takeaway-landing-pages.k.elnino-production.com/storage/resources/fonts/jet-sans/woff2/JETSansDigital-Italic.woff2") format("woff2"),
      url("https://takeaway-landing-pages.k.elnino-production.com/storage/resources/fonts/jet-sans/woff/JETSansDigital-Italic.woff") format("woff")
  }
  
  @font-face {
    font-family: "jet-bold";
    font-weight: normal;
    font-style: normal;
    src: url("https://takeaway-landing-pages.k.elnino-production.com/storage/resources/fonts/jet-sans/eot/JETSansDigital-Bold.eot"),
      url("https://takeaway-landing-pages.k.elnino-production.com/storage/resources/fonts/jet-sans/eot/JETSansDigital-Bold.eot?#iefix") format("embedded-opentype"),
      url("https://takeaway-landing-pages.k.elnino-production.com/storage/resources/fonts/jet-sans/woff2/JETSansDigital-Bold.woff2") format("woff2"),
      url("https://takeaway-landing-pages.k.elnino-production.com/storage/resources/fonts/jet-sans/woff/JETSansDigital-Bold.woff") format("woff")
  }
  
  @font-face {
    font-family: "jet-bold-Italic";
    font-weight: normal;
    font-style: normal;
    src: url("https://takeaway-landing-pages.k.elnino-production.com/storage/resources/fonts/jet-sans/eot/JETSansDigital-BoldItalic.eot"),
      url("https://takeaway-landing-pages.k.elnino-production.com/storage/resources/fonts/jet-sans/eot/JETSansDigital-BoldItalic.eot?#iefix") format("embedded-opentype"),
      url("https://takeaway-landing-pages.k.elnino-production.com/storage/resources/fonts/jet-sans/woff2/JETSansDigital-BoldItalic.woff2") format("woff2"),
      url("https://takeaway-landing-pages.k.elnino-production.com/storage/resources/fonts/jet-sans/woff/JETSansDigital-BoldItalic.woff") format("woff")
  }
  
  @font-face {
    font-family: "jet-extrabold";
    font-weight: normal;
    font-style: normal;
    src: url("https://takeaway-landing-pages.k.elnino-production.com/storage/resources/fonts/jet-sans/eot/JETSansDigital-ExtraBold.eot"),
      url("https://takeaway-landing-pages.k.elnino-production.com/storage/resources/fonts/jet-sans/eot/JETSansDigital-ExtraBold.eot?#iefix") format("embedded-opentype"),
      url("https://takeaway-landing-pages.k.elnino-production.com/storage/resources/fonts/jet-sans/woff2/JETSansDigital-ExtraBold.woff2") format("woff2"),
      url("https://takeaway-landing-pages.k.elnino-production.com/storage/resources/fonts/jet-sans/woff/JETSansDigital-ExtraBold.woff") format("woff")
  }
  
  @font-face {
    font-family: "jet-extrabold-Italic";
    font-weight: normal;
    font-style: normal;
    src: url("https://takeaway-landing-pages.k.elnino-production.com/storage/resources/fonts/jet-sans/eot/JETSansDigital-ExtraBoldItalic.eot"),
      url("https://takeaway-landing-pages.k.elnino-production.com/storage/resources/fonts/jet-sans/eot/JETSansDigital-ExtraBoldItalic.eot?#iefix") format("embedded-opentype"),
      url("https://takeaway-landing-pages.k.elnino-production.com/storage/resources/fonts/jet-sans/woff2/JETSansDigital-ExtraBoldItalic.woff2") format("woff2"),
      url("https://takeaway-landing-pages.k.elnino-production.com/storage/resources/fonts/jet-sans/woff/JETSansDigital-ExtraBoldItalic.woff") format("woff")
  }


  * {
    text-rendering: optimizeSpeed;
    font-variant-ligatures: no-common-ligature;
    font-variant-ligatures: none;
  }
  
  html,
  body {
    width: 100%;
    height: 100%;
    margin: 0;
    padding: 0;
  }
  body {
    overflow-x: hidden !important;
    background: #f8f5f2;
    font-family: 'jet-regular', 'Open Sans', 'Avant Garde', 'Century Gothic', Helvetica, Arial, sans-serif;
    color: #242f30;
    -webkit-font-smoothing: antialiased;
  }

  body.overlay-open {
    overflow: hidden;
  }

  html {
    scroll-behavior: smooth !important;
  }
  html.menu-open {
    overflow: hidden;
  }

  a {
    -webkit-transition: all 0.2s ease-In-Out;
    transition: all 0.2s ease-In-Out;
    color: #ff8000;
    text-decoration: none;
  }
  a:hover {
    color: #ff8000;
  }


  .white {
    background: #fff;
    color: #242f30;
  }
  .orange {
    background: #ff8000;
  }
  .grey {
    background: #f8f5f2;
  }
  .mozarella1 {
    background: #EFEDEA;
  }
  .yellow {
    background: #F6C243;
  }
  .pink {
    background: #F2A6B0;
  }
  .red {
    background: #F75E28;
  }
  .blue {
    background: #C1DADE;
  }
  .purple {
    background: #5B3D5B;
  }
  .charcoal {
    background: #fff;
    color: #293133;
    border: 2px inset #293133;
  }
  .charcoal:hover {
    background: #eff0f1;
    color: #293133;
  }
  .navy {
    background: #242f30;
    color: #fff;
  }
  .navy a {
    color: #fff;
  }

  /* Razor */

  .razor-up-grey {
    position: relative;
  }
  .razor-up-grey:before {
    content: "";
    position: absolute;
    z-index: 1;
    right: 0;
    left: 0;
    top: calc(-13vw + 1px);
    height: 13vw;
    width: 100%;
    margin: 0 auto;
    overflow: hidden;
    clip-path: polygon(0 100%, 100% 100%, 100% 0);
    -webkit-clip-path: polygon(0 100%, 100% 100%, 100% 0);
    background: #f5f3f1;
  }

  /* START LANG MENU */

.hide {
    display: none;
  }
  
  .select-dropdown {
    cursor: pointer;
    z-index: 1005;
    position: absolute;
    top: 23px;
    right: 24px;
    display: block;
    margin: 0;
    padding: 0;
    width: 28px;
    height: 28px;
  }
  
  .list-container {
    float: left;
    padding: 0 24px;
    min-width: 200px;
  }
  
  .select-menu {
    background: #fff;
    z-index: 1006;
    position: absolute;
    right: 24px;
    top: 70px;
    margin-top: 0;
    border-radius: 20px;
    padding: 8px 0 24px 0;
  
    cursor: pointer;
    transform: translateZ(0);
    box-shadow: 0 3px 8px 0 rgba(0, 0, 0, .05);
  }
  
  .select-menu .close {
    display: none;
  }
  
  .select-menu .menu-title {
    display: none;
    position: absolute;
    top: 26px;
    font-family: 'jet-regular', 'Open Sans', 'Avant Garde', 'Century Gothic', Helvetica, Arial, sans-serif;
    letter-spacing: 0.01em;
    font-weight: 700;
    font-size: 16px;
    color: #fff;
  }
  
  
  .select-menu span {
    padding-left: 24px;
    color: #293133;
    font-size: 14px;
    line-height: 40px;
    text-align: left;
    text-transform: none;
  }
  
  .select-menu .button-user:hover span {
    color: #ff8000;
  }
  
  .select-menu .button-user.current span {
    font-weight: 600;
  }
  
  .select-menu .title {
    padding: 12px 0;
    font-family: 'jet-bold', 'Open Sans', 'Avant Garde', 'Century Gothic', Helvetica, Arial, sans-serif;
    font-size: 18px;
    color: #293133;
  }
  
  
  .select-dropdown .locale-flag-nl:before {
    content: "";
    position: absolute;
  
    background: url("assets/img/country-svg/nl.svg");
    background-position: 50%;
    background-repeat: no-repeat;
    background-size: cover;
  
    width: 28px;
    height: 28px;
    border-radius: 50%;
    border: 4px solid #fff;
    cursor: pointer;
  }

  .select-dropdown .locale-flag-ca:before {
    content: "";
    position: absolute;
  
    background: url("assets/img/country-svg/ca.svg");
    background-position: 50%;
    background-repeat: no-repeat;
    background-size: cover;
  
    width: 28px;
    height: 28px;
    border-radius: 50%;
    border: 4px solid #fff;
    cursor: pointer;
  }

  .select-dropdown .locale-flag-au:before {
    content: "";
    position: absolute;
  
    background: url("assets/img/country-svg/au.svg");
    background-position: 50%;
    background-repeat: no-repeat;
    background-size: cover;
  
    width: 28px;
    height: 28px;
    border-radius: 50%;
    border: 4px solid #fff;
    cursor: pointer;
  }
  
  
  .select-dropdown .locale-flag-lu:before {
    content: "";
    position: absolute;
  
    background: url("assets/img/country-svg/lu.svg");
    background-position: 50%;
    background-repeat: no-repeat;
    background-size: cover;
  
    width: 28px;
    height: 28px;
    border-radius: 50%;
    border: 4px solid #fff;
    cursor: pointer;
  }
  
  .select-dropdown .locale-flag-fr:before {
    content: "";
    position: absolute;
  
    background: url("assets/img/country-svg/fr.svg");
    background-position: 50%;
    background-repeat: no-repeat;
    background-size: cover;
  
    width: 28px;
    height: 28px;
    border-radius: 50%;
    border: 4px solid #fff;
    cursor: pointer;
  }
  
  .select-dropdown .locale-flag-at:before {
    content: "";
    position: absolute;
  
    background: url("assets/img/country-svg/at.svg");
    background-position: 50%;
    background-repeat: no-repeat;
    background-size: cover;
  
    width: 28px;
    height: 28px;
    border-radius: 50%;
    border: 4px solid #fff;
    cursor: pointer;
  }
  
  .select-dropdown .locale-flag-de:before {
    content: "";
    position: absolute;
  
    background: url("assets/img/country-svg/de.svg");
    background-position: 50%;
    background-repeat: no-repeat;
    background-size: cover;
  
    width: 28px;
    height: 28px;
    border-radius: 50%;
    border: 4px solid #fff;
    cursor: pointer;
  }
  
  .select-dropdown .locale-flag-pl:before {
    content: "";
    position: absolute;
  
    background: url("assets/img/country-svg/pl.svg");
    background-position: 50%;
    background-repeat: no-repeat;
    background-size: cover;
  
    width: 28px;
    height: 28px;
    border-radius: 50%;
    border: 4px solid #fff;
    cursor: pointer;
  }
  
  .select-dropdown .locale-flag-gb:before {
    content: "";
    position: absolute;
  
    background: url("assets/img/country-svg/gb.svg");
    background-position: 50%;
    background-repeat: no-repeat;
    background-size: cover;
  
    width: 28px;
    height: 28px;
    border-radius: 50%;
    border: 4px solid #fff;
    cursor: pointer;
  }
  
  .select-dropdown .locale-flag-bg:before {
    content: "";
    position: absolute;
  
    background: url("assets/img/country-svg/bg.svg");
    background-position: 50%;
    background-repeat: no-repeat;
    background-size: cover;
  
    width: 28px;
    height: 28px;
    border-radius: 50%;
    border: 4px solid #fff;
    cursor: pointer;
  }
  
  .select-dropdown .locale-flag-it:before {
    content: "";
    position: absolute;
  
    background: url("assets/img/country-svg/it.svg");
    background-position: 50%;
    background-repeat: no-repeat;
    background-size: cover;
  
    width: 28px;
    height: 28px;
    border-radius: 50%;
    border: 4px solid #fff;
    cursor: pointer;
  }
  
  .select-dropdown .locale-flag-pt:before {
    content: "";
    position: absolute;
  
    background: url("assets/img/country-svg/pt.svg");
    background-position: 50%;
    background-repeat: no-repeat;
    background-size: cover;
  
    width: 28px;
    height: 28px;
    border-radius: 50%;
    border: 4px solid #fff;
    cursor: pointer;
  }
  
  .select-dropdown .locale-flag-ro:before {
    content: "";
    position: absolute;
  
    background: url("assets/img/country-svg/ro.svg");
    background-position: 50%;
    background-repeat: no-repeat;
    background-size: cover;
  
    width: 28px;
    height: 28px;
    border-radius: 50%;
    border: 4px solid #fff;
    cursor: pointer;
  }
  
  .select-dropdown .locale-flag-dk:before {
    content: "";
    position: absolute;
  
    background: url("assets/img/country-svg/dk.svg");
    background-position: 50%;
    background-repeat: no-repeat;
    background-size: cover;
  
    width: 28px;
    height: 28px;
    border-radius: 50%;
    border: 4px solid #fff;
    cursor: pointer;
  }
  
  .select-dropdown .locale-flag-es:before {
    content: "";
    position: absolute;
  
    background: url("assets/img/country-svg/es.svg");
    background-position: 50%;
    background-repeat: no-repeat;
    background-size: cover;
  
    width: 28px;
    height: 28px;
    border-radius: 50%;
    border: 4px solid #fff;
    cursor: pointer;
  }
  
  .select-dropdown .locale-flag-no:before {
    content: "";
    position: absolute;
  
    background: url("assets/img/country-svg/no.svg");
    background-position: 50%;
    background-repeat: no-repeat;
    background-size: cover;
  
    width: 28px;
    height: 28px;
    border-radius: 50%;
    border: 4px solid #fff;
    cursor: pointer;
  }
  
  .select-dropdown .locale-flag-ie:before {
    content: "";
    position: absolute;
  
    background: url("assets/img/country-svg/ie.svg");
    background-position: 50%;
    background-repeat: no-repeat;
    background-size: cover;
  
    width: 28px;
    height: 28px;
    border-radius: 50%;
    border: 4px solid #fff;
    cursor: pointer;
  }

  @media only screen and (max-width: 1024px) { 
    .select-dropdown {
      bottom: 25px;
      right: 20px;
      top: unset;
      display: none;
    }

    header.open .select-dropdown {
      display: block;
    }
  }
  
  
  .button-user {
    position: relative;
  }
  
  .select-menu .locale {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 20px;
  }
  
  .select-menu .locale:after {
    content: "";
    position: absolute;
    top: 10px;
  
    width: 18px;
    height: 18px;
    border-radius: 50%;
    border: 1px solid #e7e7e7;
  }
  
  .select-menu .locale-flag-nl:before {
    content: "";
    position: absolute;
    top: 11px;
    left: 1px;
  
    background: url("assets/img/country-svg/nl.svg");
    background-position: 50%;
    background-repeat: no-repeat;
    background-size: cover;
  
    width: 16px;
    height: 16px;
    border-radius: 50%;
    border: 2px solid #fff;
    cursor: pointer;
  }
  
  .select-menu .locale-flag-lu:before {
    content: "";
    position: absolute;
    top: 11px;
    left: 1px;
  
    background: url("assets/img/country-svg/lu.svg");
    background-position: 50%;
    background-repeat: no-repeat;
    background-size: cover;
  
    width: 16px;
    height: 16px;
    border-radius: 50%;
    border: 2px solid #fff;
    cursor: pointer;
  }
  
  .select-menu .locale-flag-fr:before {
    content: "";
    position: absolute;
    top: 11px;
    left: 1px;
  
    background: url("assets/img/country-svg/fr.svg");
    background-position: 50%;
    background-repeat: no-repeat;
    background-size: cover;
  
    width: 16px;
    height: 16px;
    border-radius: 50%;
    border: 2px solid #fff;
    cursor: pointer;
  }
  
  .select-menu .locale-flag-at:before {
    content: "";
    position: absolute;
    top: 11px;
    left: 1px;
  
    background: url("assets/img/country-svg/at.svg");
    background-position: 50%;
    background-repeat: no-repeat;
    background-size: cover;
  
    width: 16px;
    height: 16px;
    border-radius: 50%;
    border: 2px solid #fff;
    cursor: pointer;
  }
  
  .select-menu .locale-flag-de:before {
    content: "";
    position: absolute;
    top: 11px;
    left: 1px;
  
    background: url("assets/img/country-svg/de.svg");
    background-position: 50%;
    background-repeat: no-repeat;
    background-size: cover;
  
    width: 16px;
    height: 16px;
    border-radius: 50%;
    border: 2px solid #fff;
    cursor: pointer;
  }
  
  .select-menu .locale-flag-pl:before {
    content: "";
    position: absolute;
    top: 11px;
    left: 1px;
  
    background: url("assets/img/country-svg/pl.svg");
    background-position: 50%;
    background-repeat: no-repeat;
    background-size: cover;
  
    width: 16px;
    height: 16px;
    border-radius: 50%;
    border: 2px solid #fff;
    cursor: pointer;
  }
  
  .select-menu .locale-flag-gb:before {
    content: "";
    position: absolute;
    top: 11px;
    left: 1px;
  
    background: url("assets/img/country-svg/gb.svg");
    background-position: 50%;
    background-repeat: no-repeat;
    background-size: cover;
  
    width: 16px;
    height: 16px;
    border-radius: 50%;
    border: 2px solid #fff;
    cursor: pointer;
  }
  
  .select-menu .locale-flag-bg:before {
    content: "";
    position: absolute;
    top: 11px;
    left: 1px;
  
    background: url("assets/img/country-svg/bg.svg");
    background-position: 50%;
    background-repeat: no-repeat;
    background-size: cover;
  
    width: 16px;
    height: 16px;
    border-radius: 50%;
    border: 2px solid #fff;
    cursor: pointer;
  }
  
  .select-menu .locale-flag-it:before {
    content: "";
    position: absolute;
    top: 11px;
    left: 1px;
  
    background: url("assets/img/country-svg/it.svg");
    background-position: 50%;
    background-repeat: no-repeat;
    background-size: cover;
  
    width: 16px;
    height: 16px;
    border-radius: 50%;
    border: 2px solid #fff;
    cursor: pointer;
  }
  
  .select-menu .locale-flag-pt:before {
    content: "";
    position: absolute;
    top: 11px;
    left: 1px;
  
    background: url("assets/img/country-svg/pt.svg");
    background-position: 50%;
    background-repeat: no-repeat;
    background-size: cover;
  
    width: 16px;
    height: 16px;
    border-radius: 50%;
    border: 2px solid #fff;
    cursor: pointer;
  }
  
  .select-menu .locale-flag-ro:before {
    content: "";
    position: absolute;
    top: 11px;
    left: 1px;
  
    background: url("assets/img/country-svg/ro.svg");
    background-position: 50%;
    background-repeat: no-repeat;
    background-size: cover;
  
    width: 16px;
    height: 16px;
    border-radius: 50%;
    border: 2px solid #fff;
    cursor: pointer;
  }
  
  .select-menu .locale-flag-dk:before {
    content: "";
    position: absolute;
    top: 11px;
    left: 1px;
  
    background: url("assets/img/country-svg/dk.svg");
    background-position: 50%;
    background-repeat: no-repeat;
    background-size: cover;
  
    width: 16px;
    height: 16px;
    border-radius: 50%;
    border: 2px solid #fff;
    cursor: pointer;
  }
  
  .select-menu .locale-flag-es:before {
    content: "";
    position: absolute;
    top: 11px;
    left: 1px;
  
    background: url("assets/img/country-svg/es.svg");
    background-position: 50%;
    background-repeat: no-repeat;
    background-size: cover;
  
    width: 16px;
    height: 16px;
    border-radius: 50%;
    border: 2px solid #fff;
    cursor: pointer;
  }
  
  .select-menu .locale-flag-no:before {
    content: "";
    position: absolute;
    top: 11px;
    left: 1px;
  
    background: url("assets/img/country-svg/no.svg");
    background-position: 50%;
    background-repeat: no-repeat;
    background-size: cover;
  
    width: 16px;
    height: 16px;
    border-radius: 50%;
    border: 2px solid #fff;
    cursor: pointer;
  }
  
  .select-menu .locale-flag-ie:before {
    content: "";
    position: absolute;
    top: 11px;
    left: 1px;
  
    background: url("assets/img/country-svg/ie.svg");
    background-position: 50%;
    background-repeat: no-repeat;
    background-size: cover;
  
    width: 16px;
    height: 16px;
    border-radius: 50%;
    border: 2px solid #fff;
    cursor: pointer;
  }
  
  /* END LANG MENU */

  /* Buttons */

  .custom-button {
    z-index: 10;
    cursor: pointer;
    position: relative;
    display: block;
    overflow: hidden;
    max-width: 260px;
    width: 100%;
    -webkit-border-radius: 30px;
    -moz-border-radius: 30px;
    border-radius: 30px;
    margin: 0 auto;
  
    padding: 16px 30px 14px;
    text-align: center;
    font-family: 'jet-bold', 'Open Sans', Helvetica, sans-serif;
    font-size: 18px;
    color: #fff;
    border: 0;
  
    -webkit-transition: all 0.2s ease-In-Out;
    transition: all 0.2s ease-In-Out;
  }

  .custom-button--white {
    background: white;
    color: #262626;
    max-width: 391px;
    margin: 30px auto 0 0;
  }

  .custom-button--white:hover {
    background: #EFEDEA;
  }

  .custom-button--orange {
    background: #ff8000;
    color: white;
    max-width: 391px;
    margin: 0px auto 0 0;
  }

  .custom-button--orange:hover {
    background: #e75900;
  }

}

#ie-cookie-banner {
  display: none;
}

#ie-cookie-banner.display {
  display: block;
}
</style>